var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDownloadNew = function SvgDownloadNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#212fcc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18 -9)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(18 9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.682,3.561H8.523L6.477.834H.682A.682.682,0,0,0,0,1.516V13.789a2.045,2.045,0,0,0,2.045,2.045H14.318a2.045,2.045,0,0,0,2.045-2.045V4.243a.682.682,0,0,0-.682-.682ZM8.664,13.589a.682.682,0,0,1-.964,0L4.973,10.862A.682.682,0,0,1,5.937,9.9L7.5,11.461V6.97a.682.682,0,1,1,1.364,0v4.49L10.427,9.9a.682.682,0,1,1,.964.964Z",
    transform: "translate(25.818 16.166)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DownloadNew.f5933863.svg";
export { ForwardRef as ReactComponent };